import React from "react"
import PropTypes from "prop-types"
import { Container, A, Title, Text, Info, Photo, Split, BioWrapper } from "./styles"
import { faEnvelope, faPhoneAlt } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Markdown from "../markdown"

const CentreInfo = ({ email, phone, bio, photoUrl, paddingLess }) => {
  const hasContactDetails = email || phone

  return hasContactDetails ? (
    <Container paddingLess={paddingLess}>
      <Split>
        <Info>
          <Title>Have a question? We're here to help</Title>
          <Text spacer>
            If you need any assistance, please don't hesitate to contact us using your preferred method below.
          </Text>
          <Text>
            <FontAwesomeIcon icon={faPhoneAlt} size="1x" />
            <A href={`tel:${phone}`}>{phone}</A>
          </Text>
          <Text>
            <FontAwesomeIcon icon={faEnvelope} size="1x" />
            <A href={`mailto:${email}`}>{email}</A>
          </Text>
        </Info>
      </Split>

      {(photoUrl || bio) && (
        <Split>
          <BioWrapper>
            {photoUrl && <Photo src={photoUrl} alt="Get in touch" />}

            {bio && (
              <Text bio>
                <Markdown componentStyles={{ p: { variant: "content" } }}>{bio}</Markdown>
              </Text>
            )}
          </BioWrapper>
        </Split>
      )}
    </Container>
  ) : null
}

CentreInfo.propTypes = {
  email: PropTypes.string,
  phone: PropTypes.string,
  gridArea: PropTypes.string
}

CentreInfo.defaultProps = {
  gridArea: undefined
}

export default CentreInfo
